import { Injectable } from '@angular/core';
import { UserModel } from 'app/models/user.model';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'prehox_simulated_driver_user_id';

@Injectable({ providedIn: 'root' })
export class DriverSimulationService {
    private readonly simulatedUserId$ = new BehaviorSubject<number | null>(this.readStoredId());
    private readonly simulatedUserLabel$ = new BehaviorSubject<string>('');

    readonly selectedUserId$ = this.simulatedUserId$.asObservable();

    getSimulatedUserId(): number | null {
        return this.simulatedUserId$.value;
    }

    getSimulatedUserLabel(): string {
        return this.simulatedUserLabel$.value;
    }

    setSimulatedDriver(user: Pick<UserModel, 'user_id' | 'name'> | null): void {
        if (!user?.user_id) {
            this.clear();
            return;
        }
        const id = Number(user.user_id);
        this.simulatedUserId$.next(id);
        this.simulatedUserLabel$.next(user.name?.trim() || '');
        try {
            sessionStorage.setItem(STORAGE_KEY, String(id));
        } catch {
            /* ignore */
        }
    }

    clear(): void {
        this.simulatedUserId$.next(null);
        this.simulatedUserLabel$.next('');
        try {
            sessionStorage.removeItem(STORAGE_KEY);
        } catch {
            /* ignore */
        }
    }

    private readStoredId(): number | null {
        try {
            const raw = sessionStorage.getItem(STORAGE_KEY);
            if (!raw) return null;
            const id = Number(raw);
            return Number.isFinite(id) && id > 0 ? id : null;
        } catch {
            return null;
        }
    }
}
